import { useMemo } from 'react';

export default function RankingSection() {
  const items = useMemo(() => [
    {
      rank: 1,
      title: '娱乐圈年度最大反转：真相令人震惊',
      views: '328.6k',
      trend: 'up',
      tag: '51吃瓜在线',
      change: '+128%',
    },
    {
      rank: 2,
      title: '社会热点深度追踪：完整时间线梳理',
      views: '285.3k',
      trend: 'up',
      tag: '暗网吃瓜视频',
      change: '+95%',
    },
    {
      rank: 3,
      title: '直播名场面：暗网吃瓜直播高光合集',
      views: '241.7k',
      trend: 'up',
      tag: '暗网吃瓜直播',
      change: '+67%',
    },
    {
      rank: 4,
      title: '51cg吃瓜频道：本周最热视频TOP10',
      views: '198.2k',
      trend: 'down',
      tag: '51cg吃瓜',
      change: '-12%',
    },
    {
      rank: 5,
      title: '在线暗网吃瓜：匿名社区热议话题',
      views: '165.9k',
      trend: 'up',
      tag: '吃瓜视频',
      change: '+34%',
    },
  ], []);

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            吃瓜排行
          </h2>
          <p className="text-sm text-foreground-500 mt-3">本周最受欢迎的吃瓜内容热度榜单</p>
        </div>

        <div className="space-y-3">
          {items.map((item) => (
            <div
              key={item.rank}
              className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 flex items-center gap-4 group hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 font-bold text-lg ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-300 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded bg-primary-50 text-primary-600 font-medium">
                    {item.tag}
                  </span>
                  <span className={`text-xs flex items-center gap-0.5 ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
                  }`}>
                    <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
                    {item.change}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mt-1.5 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              <div className="text-right shrink-0">
                <p className="text-sm font-bold text-foreground-700">{item.views}</p>
                <p className="text-xs text-foreground-400">次观看</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}